export default __webpack_public_path__ + "store-placeholder.8cd134f.png";